var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExport = function SvgExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.727 3h6.906l5.18 5.383v4.223a5.4 5.4 0 0 0-1.063-.106c-2.934 0-5.312 2.363-5.312 5.278 0 1.188.395 2.284 1.062 3.166H4.718c-.95 0-1.718-.807-1.718-1.794l.009-14.356C3.009 3.808 3.777 3 4.727 3m6.043 1.346V9.28h4.748z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.535 14v6h-2v-2.586l-4.12 4.121L13 20.121 17.121 16h-2.586v-2z"
  })));
};
export default SvgExport;